import axios from "axios";
import { BASE_API_URL } from "@/appConstants";
import router from "@/router/router";
import loader from "@/plugins/loader.plugin";
import i18n from "@/i18n";

export default {
    namespaced: true,
    state: () => {
        return {
            dish: null,
            menu: null,
        }
    },
    mutations: {
        SET_DISH_ITEM(state, dish) {
            state.dish = dish;
        },
        SET_MENU(state, menu) {
            state.menu = menu;
        },
    },
    actions: {
        GET_DISH_ITEM({ commit, rootState }, itemId) {
            if (itemId !== null && itemId !== undefined) {
                loader.show();

                return axios.get(`${BASE_API_URL}item?token=${rootState.companyData.token}&item_id=${itemId}`)
                    .then(response => {
                        if (response.data.status === 200) {
                            commit('SET_DISH_ITEM', response.data.item);
                            return true;
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            router.push({
                                name: 'error',
                                params: {
                                    errorTitle: "Error Loading",
                                    errorMessage: "Error loading dish item. Please try again later."
                                }
                            })
                        }
                    })
                    .finally(() => {
                        loader.hide()
                    })
            }

        },
        GET_FULL_MENU({ state, commit, rootState }, forceUpdate = false) {
            if (!forceUpdate && state.menu !== null) {
                return true;
            }
            loader.show();

            const endpoint = BASE_API_URL +
                'getfullmenu?token=' + rootState.companyData.token +
                '&pref_lang_code=' + rootState.prefLangCode;


            return axios.get(endpoint).then(
                response => {
                    if (response.status === 200) {
                        const res = response.data.map(d => {
                            return { ...d, id: d.category_id };
                        });
                        commit('SET_MENU', res);
                        return true;
                    }
                }
            ).catch(error => {
                if (error.response) {
                    router.push({
                        name: 'error',
                        params: {
                            errorTitle: "Error Loading",
                            errorMessage: "Error loading menu item. Please try again later."
                        }
                    })
                }
            }).finally(() => {
                loader.hide()
            })
        }
    },
    getters: {
        getDish: state => state.dish,
        getMenu: state => state.menu,
        getPopular: (state, getters, rootState, rootGetter) => {
            if (rootGetter.getCompanyData.featuredItems.length !== 0) {
                const popular = {
                    id: 'popular',
                    name: i18n.t('pages.menu.blocks.popular.title'),
                    items: rootGetter.getCompanyData.featuredItems,
                }
                return popular;
            }
            return null;
        },
    }
}
